import jQuery from 'jquery';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import './assets/css/styles.pcss';
import './assets/ts/scripts.ts';

declare global {
  interface Window {
    $: typeof jQuery;
    jQuery: typeof jQuery;
  }
}

// ts-ignore
window.jQuery = jQuery
window.$ = jQuery